import React from "react";
import "./Service.scss";
import freeShip from "~/assets/images/transportation.png";
import contact from "~/assets/images/Contact the switchboard.png";
import ensure from "~/assets/images/ensure benefits.png";

function Service() {
  return (
    <div className="my-5">
      <ul className="list-services">
        <li className="items">
          <div className="img-icon">
            <img src={freeShip} alt="" />
          </div>
          <h5 className="title">GIAO HÀNG MIỄN PHÍ VÀ NHANH CHÓNG</h5>
          <p className="sub-title">
            Giao hàng miễn phí cho tất cả các đơn hàng trên $140
          </p>
        </li>
        <li className="items">
          <div className="img-icon">
            <img src={contact} alt="" />
          </div>
          <h5 className="title">DỊCH VỤ KHÁCH HÀNG 24/7/h5/</h5>
          <p className="sub-title">Hỗ trợ khách hàng thân thiện 24/7</p>
        </li>
        <li className="items">
          <div className="img-icon">
            <img src={ensure} alt="" />
          </div>
          <h5 className="title">ĐẢM BẢO HOÀN LẠI TIỀN 100%</h5>
          <p className="sub-title">Chúng tôi hoàn lại tiền trong vòng 7 ngày</p>
        </li>
      </ul>
    </div>
  );
}

export default Service;
